import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import arrowUpIcon from 'utils/icon/icon_collapse-up-blue.svg';
import arrowDownIcon from 'utils/icon/icon_collapse-down-blue.svg';

interface IProps {
  onClick: (e: any) => void;
  collapseShow: boolean;
}

const CollapseArrow: React.FC<IProps> = ({ onClick, collapseShow }) => {
  return (
    <CollapseWrapper onClick={onClick}>
      <img src={collapseShow ? arrowUpIcon : arrowDownIcon} alt='arrow' />
      <p className='text'>{collapseShow ? 'Collapse' : 'Expand'}</p>
    </CollapseWrapper>
  );
};

export default CollapseArrow;

const CollapseWrapper = styled.div`
  text-align: right;
  cursor: pointer;
  width: fit-content;
  display: flex;
  align-items: center;
  & > * + * {
    margin-left: 3px;
  }
  .text {
    color: ${theme.colors.blue_500};
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.bold};
    line-height: 24px;
    letter-spacing: 0.1px;
  }
`;
